import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Box,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Search_Wishlist from "./Search_Wishlist";
import EmptyWishlist from "./Empty_WishList";
import { useEffect, useState } from "react";
import { authFetch } from "../../../api";
import Loader from "../../components/Loader/Loader";
import GlobalMessageModal from "../../../STMPages/components/customPopup/GlobalMessageModal";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfimationPopup from "../../../STMPages/components/customPopup/ConfimationPopup";
import CustomPagination from "../../components/pagination/CustomPagination";
import { useWishlist } from "../../context/WishlistContext";
import FundsCalculatorModal from "../funds-calculator/funds-calculator-modal";
import WishlistCard from "./WishlistCard";
// import FundsCalculatorModal from "../../components/Modal/Fund_Calculator";

export default function SAP_Wishlist() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const userId = localStorage.getItem("userId");
  const [openModal, setOpenModal] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    nextPage: null,
    prevPage: null,
  });
  const [openCalc, setOpenCalc] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const { fetchWishlist } = useWishlist();

  const fetchWishList = async (page = 1, limit = 9) => {
    try {
      setLoading(true);
      const userId = localStorage.getItem("userId");
      if (!userId) return;

      const response = await authFetch(
        `course-wishlist/show-user-wishlist-courses?page=${page}&limit=${limit}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id: userId }),
        },
      );

      const data = await response.json();

      const coursesArray = data?.data ?? [];
      setCourses(coursesArray);

      if (data?.pagination) {
        setPagination({
          currentPage: data.pagination.currentPage,
          totalPages: data.pagination.totalPages,
          nextPage: data.pagination.nextPage
            ? Number(new URL(data.pagination.nextPage).searchParams.get("page"))
            : null,
          prevPage: data.pagination.previousPage // ❌ not present
            ? Number(
                new URL(data.pagination.previousPage).searchParams.get("page"),
              )
            : data.pagination.currentPage > 1
              ? data.pagination.currentPage - 1
              : null,
        });
      }
    } catch (err) {
      console.error("Error fetching wishlist:", err);
      setCourses([]);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveWishlist = async (courseId) => {
    try {
      const response = await authFetch("course-wishlist/add-shortlist", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: userId,
          course_id: [courseId],
        }),
      });

      if (response.status === 200) {
        setCourses((prev) => prev.filter((c) => c.id !== courseId));
        fetchWishlist();
      }
    } catch (err) {
      console.error("Failed to remove from wishlist:", err);
    }
  };

  const handledeleteAll = async () => {
    try {
      const response = await authFetch("course-wishlist/remove-user-wishlist", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: userId,
        }),
      });
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (err) {
      console.error("Failed to add to wishlist:", err);
    }
    fetchWishList();
  };

  useEffect(() => {
    fetchWishList();
  }, []);

  return (
    <>
      {openModal && (
        <ConfimationPopup
          handleClose={() => setOpenModal(false)}
          open={openModal}
          component={
            <GlobalMessageModal
              text="Are you sure?"
              subText="This will remove all courses from your shortlist."
              buttonTitle="Yes, Remove All"
              startIcon={<DeleteIcon />}
              handleClose={() => {
                setOpenModal(false);
                handledeleteAll();
              }}
            />
          }
        />
      )}

      {loading ? (
        <Loader text={"Loading Shortlists...."} />
      ) : (
        <div className="font-inter px-6 py-4">
          {/* Header */}
          <div className="mb-6 flex items-center justify-between">
            <a
              href="/sap/courses"
              className="flex items-center gap-2 text-[#572575]"
            >
              <span className="text-lg">←</span>
              <h1 className="text-[32px] font-normal">My Wishlist</h1>
            </a>

            <button
              onClick={() => setOpenModal(true)}
              disabled={loading}
              className="rounded-lg border border-[#572575] px-5 py-2 font-semibold text-[#572575] hover:bg-[#f6eefb]"
            >
              Remove all
            </button>
          </div>

          {/* Grid */}
          {courses.length === 0 ? (
            <div className="flex justify-center py-10">
              <EmptyWishlist />
            </div>
          ) : (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {courses.map((course) => (
                <WishlistCard
                  key={course.id}
                  course={course}
                  onRemove={handleRemoveWishlist}
                  setOpenCalc={setOpenCalc}
                  setSelectedCourse={setSelectedCourse}
                  selectedCourse={selectedCourse}
                  openCalc={openCalc}
                  // onEnroll={handleCheck}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}
